import { datadogRum } from '@datadog/browser-rum';

export class AnalyticsService {

  public static readonly instance = new AnalyticsService();

  setUser (
    id: string,
    name: string,
    email: string,) {
    datadogRum.setUser({
      id,
      name,
      email,
    });
  }

  clearUser() {
    datadogRum.clearUser();
  }

}